module.exports = __webpack_public_path__ + "static/media/newsletter-december-2023-3.bef30ebf.jpg";